<template> 
    <div :style="cssProps">
        <div v-if="computedLimitList.length == 0 && computedList == 0">
            <v-card class="rounded-card" style="padding:20px; margin-bottom: 10px;">
                <v-card-title>No Transactions</v-card-title>
            </v-card>
        </div>
        <div v-if="filterDate == 'false'">
            <div v-for="(transaction, index) in computedLimitList" :key="index">
                <transaction-card :accountId="transaction.accountId" :amount="transaction.amount"
                    :createdBy="transaction.createdBy" :fromAccount="transaction.fromAccount"
                    :fromLedger="transaction.fromLedger" :ledger="transaction.ledger"
                    :linkedTxnId="transaction.linkedTxnId" :quantity="transaction.quantity"
                    :reference="transaction.reference" :site="transaction.site" :source="transaction.source"
                    :transactionDate="transaction.transactionDate" :type="transaction.type"
                    :linkedTransactions="getLinkedTransactions(transaction.id, transaction.linkedTxnId)">
                </transaction-card>
            </div>

        </div>
        <div v-if="filterDate == 'true'">
            <div v-for="(transaction, index) in computedList" :key="index">
                <transaction-card :accountId="transaction.accountId" :amount="transaction.amount"
                    :createdBy="transaction.createdBy" :fromAccount="transaction.fromAccount"
                    :fromLedger="transaction.fromLedger" :ledger="transaction.ledger"
                    :linkedTxnId="transaction.linkedTxnId" :quantity="transaction.quantity"
                    :reference="transaction.reference" :site="transaction.site" :source="transaction.source"
                    :transactionDate="transaction.transactionDate" :type="transaction.type"
                    :linkedTransactions="getLinkedTransactions(transaction.id, transaction.linkedTxnId)">
                </transaction-card>
            </div>
        </div>
    </div>
</template>
<!-- put a smaller component to hold each transaction  -->
<script>


import { mapGetters } from 'vuex';
import TransactionCard from './TransactionCard.vue';
export default {
    name: "TransactionLine",
    components: {
        TransactionCard
    },
    props: {
        allTransactions: Array,
        filterOptions: String,
        monthSelection: Number,
        yearSelection: String,
        limit: String,
        filterDate: String,
        takenHeight: String,
        filterType: Number,
        sizeOfMonths: Number,
        pendingPayments: Array,
    },
    data: () => ({
        computedList: [],
        computedLimitList: [],
    }),
    computed: {
        cssProps() {
            let style = "height:" + (window.innerHeight - this.$props.takenHeight) + "px; overflow-y:scroll; overflow-x:hidden;";
            return style;
        },
        ...mapGetters([
            'getAccountBalance',
        ]),
    },
    mounted() {
        if (this.filterDate == "true")
            this.computeFilterList();
        else
            this.computeLimitList();
    },
    watch: {
        getAccountBalance:{
            handler(accountBalance){
                if(accountBalance.balance != null && this.filterDate == "false")
                    this.computeLimitList();
            }
        },
        allTransactions: function () {

            if (this.filterDate == "true")
                this.computeFilterList();
            else
                this.computeLimitList();
        },
        monthSelection: function () {
            if (this.filterDate == "true")
                this.computeFilterList();
            else
                this.computeLimitList();
        },
        yearSelection: function () {
            if (this.filterDate == "true")
                this.computeFilterList();
            else
                this.computeLimitList();
        },
        filterType: function () {
            if (this.filterDate == "true")
                this.computeFilterList();
            else
                this.computeLimitList();
        }
    },
    methods: {
        getLinkedTransactions(id, linkedTxnId) {
            //Finds linked transactions. If has -1 find other transactions with id as there linked. 
            //If not -1 then find that transaction by id and that linked until -1. 
            let linkedTransactionsList = [];
            if (linkedTxnId == -1) {
                this.allTransactions.forEach(value => {
                    if (value.linkedTxnId == id)
                        linkedTransactionsList.push(value);
                })
            } else {
                //get linked to this transaction (Directly)
                this.allTransactions.forEach(value => {
                    if (value.id == linkedTxnId)
                        linkedTransactionsList.push(value);
                })
                //get linked to those (In-directly)
                linkedTransactionsList.forEach(value => {
                    if (value.linkedTxnId != -1) {
                        this.allTransactions.forEach(value2 => {
                            if (value.linkedTxnId == value2.id)
                                linkedTransactionsList.push(value2);
                        })
                    }
                })
            }
            return linkedTransactionsList;
        },
        // The two transaction list calc methods could be renamed to be obvious what they do,
        // as in this app they are used once each. Could get rid of limit.
        // And selecting the month year could also go as date range now in api call.

        //This method calculates the all transactions list, by month.
        computeFilterList: function () {
            const filteredList = [];
            if (this.$props.allTransactions != null) {
                this.$props.allTransactions.forEach(element => {
                    let date = new Date(element.transactionDate);
                    if (date.getFullYear() == this.yearSelection) {
                        if (date.getMonth() == this.$props.sizeOfMonths - (this.monthSelection + 1)) {
                            filteredList.push(element);
                        }
                    }
                });
                this.computedList = filteredList;

                //Sort list to latest first
                this.computedList.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
                this.computedList.reverse();
            }

        },
        //This method calculates the homepage list with all, in and out.
        computeLimitList() {
            let newList = [];
            if (this.$props.allTransactions != null) {
                if (this.$props.filterType != 2) {
                    this.$props.allTransactions.forEach((value) => {
                        if ((value.type == "CHIP" || value.type == "CHIP2") && this.$props.filterType == 0) {
                            newList.push(value);
                        }
                        if (value.type == "PAY-OUT" && this.$props.filterType == 1) {
                            newList.push(value);
                        }
                    });
                } else {
                    //copy of array to avoid infinite loop as alltransactions has watcher
                    newList = [...this.$props.allTransactions];
                }

                //Add pendingPayments to the payouts
                // if (this.getAccountBalance.balance != null && this.$props.filterType == 2) {
                //     this.getAccountBalance.pendingPayments.forEach(el => {
                //         let toTransaction = {
                //             id: el.id,
                //             accountId: el.accountId,
                //             amount: el.amount*-1,
                //             createdBy: el.createdBy,
                //             fromAccount: -1,
                //             fromLedger: "PARTNER",
                //             ledger: "PARTNER",
                //             linkedTxnId: -1,
                //             quantity: 1,
                //             reference: "Ref:" + el.id,
                //             site: "Paying out",
                //             source: "Paying out",
                //             transactionDate: el.requestedDate,
                //             type: "PENDING PAYMENT",
                //             linkedTransactions: [],
                //         }
                //         newList.push(toTransaction);
                //     })
                // }
                //Sort list to latest first
                // newList.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate));
                newList.reverse();
                //If limit is defined then will limit the list here
                if (newList.length > parseInt(this.limit)) {
                    let limitInt = parseInt(this.limit);
                    this.computedLimitList = parseInt(limitInt) ? newList.slice(0, limitInt) : newList;
                    return;
                }
                this.computedLimitList = newList;
            }
        },
    }
}
</script>

<style scoped>
</style>